import { Component } from 'react';
import { withRouter } from 'react-router';

import { connect } from 'react-redux';
import { withTranslation } from '../../lib/translate';
import './index.css';
import Layout from '../../components/layout';
import { IonAlert, IonButton, IonIcon, IonInput, IonItem } from '@ionic/react';
import { chevronBack } from 'ionicons/icons';
import { NormalText, Spacer, Title } from '../../components/common';
import { clearRegisterForm, sendEmailCode, sendValidationEmail, setCommonModal } from '../../store/actions';
import { forwardTo, goBack, isWebConfig } from '../../lib/utils';
import Loading from '../../components/spinner';

class VerifyAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: null,
      formErrors: {},
      cancelVerificationModalOpen: false
    }

  }
  resendValidationEmail = () => {
    this.props.dispatch(sendValidationEmail())
  }
  componentDidMount = () => {
    const { profile, auth } = this.props;
    this.props.dispatch(clearRegisterForm())

    const isAuth = auth.loggedIn;
    const valid = profile.email_verified || false;
    if (isAuth && valid) {
      isWebConfig() ? forwardTo("/order") : forwardTo("/homepage")
    }
  }
  sendCode = () => {
    this.props.dispatch(sendEmailCode({ code: this.state.code,showTutorialModal:this.props.location?.state?.showTutorialModal }))

  }
  render() {
    const { __ } = this.props;
    const { code, formErrors } = this.state

    return (
      <Layout
        showBack
        showHeader
        showFooter
        color="transparent"
        headerTitle="My Account"
        hideBack={true}
        hideSecondToolbar={true}
      >
        <Loading>
          <div className='absolute-content scrollable-y'>
            <div className='page-secondary-header' style={{ flex: 'unset' }}>
              <IonIcon onClick={() => goBack()} className='page-secondary-header-back' color="gray" icon={chevronBack}></IonIcon>

              <Title className="secondary-font dark-color">{__('Verify your email')}</Title>

            </div>
            <div className='centered' style={{ display: 'grid' }}>
              <NormalText>{__("We've sent a 6-digit verification code to your email. Enter it below to complete your registration and start earning free pizza.")}</NormalText>
              <Spacer size={1} />
              <div style={{ width: '90%' }} className="input-field-container">
                <IonItem
                  style={{ width: '100%' }}
                  lines="none"
                  className={`input-field-wrapper input-field-wrapper-colored no-border ${formErrors.code ? 'invalid' : ''}`}
                >
                  <IonInput
                    placeholder={__('Enter code')}
                    onIonInput={(e) => this.setState({ code: e.target.value })}
                    required={true}
                    type="number"
                    pattern="number"
                    inputmode="tel"
                    value={code}
                  ></IonInput>
                </IonItem>
              </div>
              <Spacer size={1} />

              <IonButton disabled={this.state?.code?.length < 6 || !this.state.code} onClick={() => this.sendCode()} className='block' color={'secondary'}>{__('Verify')}</IonButton>
              <Spacer size={1} />

              <NormalText className='block'>{__("Didn't receive the code?")}</NormalText>
              <IonButton onClick={() => this.resendValidationEmail()} className='link underlined block' color={'secondary'} fill='clear' >{__("Resend code")}</IonButton>
              <Spacer size={1} />

              <IonButton onClick={() => this.setState({ cancelVerificationModalOpen: true })} className='link underlined block' fill='clear' >{__("Verify email address later")}</IonButton>
            </div>
          </div>
          <IonAlert
            isOpen={this.state.cancelVerificationModalOpen}
            onDidDismiss={() => this.setState({ cancelVerificationModalOpen: false })}
            header={__('Skip email verification')}
            message="You will need to verify your email address before you can join a table, or redeem any loyalty rewards."
            cssClass="no-table-alert two-button-alert"
            color="secondary"
            buttons={[
              {
                cssClass: 'two-button-secondary',
                text: 'Verify later',
                role: 'confirm',
                handler: () => {

                  if (this.props.location?.state?.showTutorialModal) {
                    this.props.dispatch(setCommonModal('isTutorialModalOpen', true));
                  }
                  isWebConfig() ? forwardTo("/order") : forwardTo("/homepage")

                }

              },
              {
                cssClass: 'two-button-gray',
                text: 'Cancel',
                role: 'cancel',
                handler: () => this.setState({ cancelVerificationModalOpen: false }),


              },
            ]}
          />
        </Loading>
      </Layout>
    );
  }
}

const stateToProps = (store) => {
  const { profile, auth } = store.profile;
  return {
    profile,
    auth,
  };
};

export default connect(stateToProps)(withRouter(withTranslation(VerifyAccount)));
